import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, BaseApi, COMMON_URL } from "@edl-development/edl-common";
import { Observable, map } from 'rxjs';

@Injectable()
export class PvaasDataApi extends BaseApi {


  constructor(
    @Inject(BASE_URL) private baseUri: string,
    @Inject(COMMON_URL) private commonUrl: string,
    private http: HttpClient
  ) {
    super();
  }

  getTemplate() {
    return this.http
      .get(this.commonUrl + '/onboarding/template', {
        responseType: 'blob',
      });
  }


  uploadPvaasData({
    fileToUpload, type, schoolYear
    }: {
      fileToUpload: File;
      type: number;
      schoolYear: string;
    }) {
      let formData: FormData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      formData.append('Type', type.toString());
      formData.append('SchoolYear', schoolYear);
      return this.http.post(this.baseUri + '/PvaasData', formData);
    }

    getUploadEvents (increment:number = 10, index:number = 0){
      return this.http.get(this.baseUri + `/PvaasData/uploads/${increment}/${index}` );
    }

    getPvaasData (schoolYear:string) {
      return this.http.get(this.baseUri + `/PvaasData/data/${schoolYear}` );
    }


    deletePvaasData(ViewSchoolYear: string) {
      return this.http.delete(this.baseUri + `/PvaasData/data/${ViewSchoolYear}`);
    }


}
